import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from '../../base';
import { RelocateStock, RelocateStockReport } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class RelocateStockService extends TmsWebBaseService {
  constructor() {
    super('RelocateStock');
  }

  getStockForRelocate(search: string): Observable<RelocateStock[]> {
    return this.httpService.get<RelocateStock[]>(`${this.apiUrl}/GetStockForRelocate?search=${search}`);
  }

  relocateStock(
    ids: string[],
    newLocationId: string,
    unBondInstructionHeaderId: string,
    comments: string,
  ): Observable<RelocateStockReport> {
    return this.httpService.post<RelocateStockReport>(`${this.apiUrl}/RelocateStock`, {
      ids,
      newLocationId,
      unBondInstructionHeaderId,
      comments,
    });
  }
}
